import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';

export function disallowedValuesValidator(disallowedValues: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value === null || control.value === undefined || control.value === '') {
      return null;
    }

    disallowedValues = disallowedValues.filter(value => value !== null && value !== undefined);

    const isDisallowed = disallowedValues.map(x => x.toLowerCase()).includes(control.value.toLowerCase());

    return isDisallowed ? { disallowedValues: { value: control.value, disallowedValues } } : null;
  };
}
